import React from 'react';
import { TemplateProps } from '../types';

export const DialogHeader = ({ children }: TemplateProps): JSX.Element => (
  <div className='syte-dialog-header'>{children}</div>
);
